import React, { useState, useEffect } from "react";
import styles from "./Cover.module.css";
import LogoCover from "../../images/Logo_Cover.png";

const CoverComponent = ({
  image,
  showLogo = false,
  text = "",
  height = 0,
  textSize = 0,
}) => {
  const [textWords, setTextWords] = useState([]);

  let coverStyle = styles.cover;
  if (height > 0) coverStyle = styles.cover50;

  let textSizeStyle = styles.text;
  if (textSize > 0) textSizeStyle = styles.text50;

  useEffect(() => {
    const textArr = text.split(" ");
    return setTextWords(textArr);
  }, [text]);

  return (
    <div className={coverStyle}>
      <img
        className={styles.backgroundImage}
        src={image}
        alt="Imagem de Capa"
      />
      {showLogo ? (
        <img
          className={styles.logo}
          src={LogoCover}
          alt="Logo Hemap Consulting"
        />
      ) : (
        <div className={styles.textDiv}>
          {textWords.map((elem, index) => {
            return (
              <div key={index} className={textSizeStyle}>
                {elem}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CoverComponent;
